<template>
    <div>
        <v-layout align-start justify-space-between row fill-height>
            <v-flex xs12 sm12 md12 sm4 md4>

                <v-data-table :headers="headersSummary" :items="flight.FlightSegments" class="elevation-1 mb-3"
                    hide-actions>
                    <template v-slot:items="props">
                        <td class="text-xs-left">
                            {{ props.item.OperatingAirline }} {{ '-' }} <span v-if="props.item.DirectionInd == 0"> Gidiş
                            </span>
                            <span v-if="props.item.DirectionInd == 1"> Dönüş </span>
                        </td>
                        <td class="text-xs-left">
                            {{ props.item.FlightNumber }} -
                            {{ props.item.DepartureAirportCode }} -
                            {{ props.item.ArrivalAirportCode }}
                        </td>
                        <td class="text-xs-left">
                            {{ formatDate(props.item.DepartureDate) }} -
                            {{ props.item.DepartureTime }}
                        </td>
                        <td class="text-xs-left">
                            {{ formatDate(props.item.ArrivalDate) }} -
                            {{ props.item.ArrivalTime }}
                        </td>
                        <td class="text-xs-left">{{ props.item.EquipmentType }}</td>
                        <td class="text-xs-left">
                            {{ props.item.CabinType }}
                        </td>
                        <td class="text-xs-left">
                            {{ props.item.ResBookDesigQuantity }}
                        </td>
                    </template>
                </v-data-table>

                <div v-if="1 == 0">
                    <v-data-table :headers="headers" class="elevation-1" :items="flight.SelectableFares" hide-actions>
                        <template v-slot:items="props">
                            <td class="text-xs-left">
                                {{ props.item.PassengerTypeCode }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.BaseFare }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.TotalTax }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.ServiceFee }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.PassengerTypeQuantity }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.BaggageAllowance }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.TotalFare }}
                            </td>
                        </template>

                        <template v-slot:footer>
                            <td>
                                <strong> {{ $t("Totals") }} </strong>
                            </td>
                            <td>
                                <strong>{{ calculateFooter(1, i) }}</strong>
                            </td>
                            <td>
                                <strong> {{ calculateFooter(2, i) }} </strong>
                            </td>
                            <td>
                                <strong> {{ calculateFooter(3, i) }} </strong>
                            </td>
                            <td>
                                <strong> {{ calculateFooter(4, i) }} </strong>
                            </td>
                            <td>
                                <strong></strong>
                            </td>
                            <td>
                                <strong> {{ calculateFooter(5, i) }} </strong>
                            </td>
                        </template>
                    </v-data-table>
                </div>

            </v-flex>
        </v-layout>
    </div>
</template>
<script>
export default {
    name: "FlightDetails",
    props: {
        flight: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            headersSummary: [
                {
                    text: this.$t("Airline"),
                    sortable: false,
                },
                {
                    text: this.$t("Flight"),
                    sortable: false,
                },
                {
                    text: this.$t("Departure-TWO"),
                    sortable: false,
                },
                {
                    text: this.$t("Arrival"),
                    sortable: false,
                },
                {
                    text: this.$t("Plane-Type"),
                    sortable: false,
                },
                {
                    text: this.$t("Cabin"),
                    sortable: false,
                },
                {
                    text: this.$t("Seat"),
                    sortable: false,
                },
            ],
        };
    },
    methods: {
        formatDate(date) {
            var dateArray = date.split(" ");
            return dateArray[0];
        },
        calculateFooter(type) {
            // type 1 : BaseFare , 2: TotalTax , 3: ServiceFee , 4 : PassengerTypeQuantity , 5:TotalFare
            switch (type) {
                case 1:
                    var _totalBaseFare = 0;
                    this.flight.PricingInfo.FareBreakdowns.forEach(
                        (element) => {
                            _totalBaseFare = _totalBaseFare + element.BaseFare;
                        }
                    );
                    return _totalBaseFare;
                case 2:
                    var _totalTax = 0;
                    this.flight.PricingInfo.FareBreakdowns.forEach(
                        (element) => {
                            _totalTax = _totalTax + element.TotalTax;
                        }
                    );
                    return _totalTax;
                case 3:
                    var _totalServiceFee = 0;
                    this.flight.PricingInfo.FareBreakdowns.forEach(
                        (element) => {
                            _totalServiceFee = _totalServiceFee + element.ServiceFee;
                        }
                    );
                    return _totalServiceFee;
                case 4:
                    var _totalPassengerTypeQuantity = 0;
                    this.flight.PricingInfo.FareBreakdowns.forEach(
                        (element) => {
                            _totalPassengerTypeQuantity =
                                _totalPassengerTypeQuantity + element.PassengerTypeQuantity;
                        }
                    );
                    return _totalPassengerTypeQuantity;
                case 5:
                    var _totalTotalFare = 0;
                    this.flight.PricingInfo.FareBreakdowns.forEach(
                        (element) => {
                            _totalTotalFare = _totalTotalFare + element.TotalFare;
                        }
                    );
                    return _totalTotalFare;

                default:
                    break;
            }
        },
    }
};
</script>